import { render, staticRenderFns } from "./AamsLetterUsageApproval.vue?vue&type=template&id=27c4cd40&scoped=true&"
import script from "./AamsLetterUsageApproval.vue?vue&type=script&lang=js&"
export * from "./AamsLetterUsageApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4cd40",
  null
  
)

export default component.exports